import React, { useState } from "react"
import { PlusOutlined } from "@ant-design/icons"
import {
  Col,
  Drawer,
  Form,
  Image,
  Input, InputNumber,
  notification,
  Radio,
  Row,
  Upload,
} from "antd"
import api from "src/api"
import { Button } from "src/components/actions/button"
import { CloseSvg, RotateClockwiseSvg, SaveSvg } from "src/components/Svg"
import { TinyMCE } from "src/components/Wysiwyg/TinyMCE"
//import { STATE_MEDIA } from "src/config"
import { useAppData } from "src/store/app-data"
import { getFormData } from "src/utils/helpers"
import styled from "styled-components"

export function DrawerCreate({ onClose }) {
  const layoutConfig = useAppData((state) => state.layoutConfig)

  const [createForm] = Form.useForm()
  const [loading, setLoading] = useState(false)
  const [previewVisible, setPreviewVisible] = useState(false)
  const [previewImage, setPreviewImage] = useState({})
  const [fileList, setFileList] = useState([])
  const [fileListDesktop, setFileListDesktop] = useState([])

  const onChange = (file) => {
    setFileList(file ? [file] : [])
  }

  const onChangeDesktop = (file) => {
    setFileListDesktop(file ? [file] : [])
  }

  function onBeforeUpload(file) {
    handleChanges(file)
    return false
  }

  async function handleChangesDesktop(file) {
    if (file instanceof File) {
      file.url = await URL.createObjectURL(file)
    }
    onChangeDesktop(file)
  }

  function onBeforeUploadDesktop(file) {
    handleChangesDesktop(file)
    return false
  }

  async function handleChanges(file) {
    if (file instanceof File) {
      file.url = await URL.createObjectURL(file)
    }
    onChange(file)
  }

  function onRemove() {
    createForm.setFieldValue("image", null)
    onChange(null)
  }

  function onRemoveDesktop() {
    createForm.setFieldValue("desktopImage", null)
    onChangeDesktop(null)
  }

  function onPreview(file) {
    setPreviewImage(file)
    setPreviewVisible(!previewVisible)
  }

  const onFinishCreate = async (values) => {
    setLoading(true)
    const formData = getFormData({ values, image: fileList[0], desktopImage: fileListDesktop[0] })

    try {
      await api.post("live-love-work", formData)

      notification.success({ message: "Объект добавлен" })
      createForm.resetFields()
      onClose()
    } catch (error) {
      notification.error({ message: "Ошибка добавления" })
      console.log("Ошибка добавления", error)
    } finally {
      setLoading(false)
    }
  }

  return (
    <Drawer
      width={layoutConfig.isMobile ? "90%" : "80%"}
      title={"Добавить объект"}
      onClose={onClose}
      open
    >
      <Form form={createForm} layout={"vertical"} onFinish={onFinishCreate}>
        <StyledFormItem
          key={0 + "_title"}
          label={"Заголовок"}
          name={"title"}
          rules={[
            {
              required: true,
              message: "Пожалуйста введите заголовок!",
            },
          ]}
        >
          <Input value={""} type={"text"} maxLength={200} placeholder={"Заголовок"} />
        </StyledFormItem>
        <StyledFormItem
          key={0 + "_description"}
          label={"Подзаголовок"}
          name={"description"}
          rules={[
            {
              required: true,
              message: "Пожалуйста введите подзаголовок!",
            },
          ]}
        >
          <Input value={""} type={"text"} maxLength={200} placeholder={"Подзаголовок"} />
        </StyledFormItem>

        <StyledFormItem
            key={0 + "_sortWeight"}
            label={"Позиция в списке"}
            name={"sortWeight"}
            rules={[
              {
                required: true,
                message: "Введите позицию!",
              },
            ]}
        >
          <InputNumber
              min={0}
              style={{
                width: "100%",
              }}
              placeholder={"Позиция"}
          />
        </StyledFormItem>

        <StyledFormItem
          key={0 + "_content"}
          label={"Контент"}
          name={"content"}
          rules={[
            {
              required: true,
              message: "Пожалуйста введите!",
            },
          ]}
        >
          <TinyMCE />
        </StyledFormItem>
        <StyledFormItem
          key={0 + "_isActive"}
          label={"Включен"}
          name={"isActive"}
          rules={[
            {
              required: true,
              message: "Please select!",
            },
          ]}
          initialValue={true}
        >
          <Radio.Group buttonStyle="solid">
            <Radio.Button value={true}>Да</Radio.Button>
            <Radio.Button value={false}>Нет</Radio.Button>
          </Radio.Group>
        </StyledFormItem>
        <StyledImage
            alt={previewImage.name || "Превью"}
            preview={{
              visible: previewVisible,
              onVisibleChange: () => setPreviewVisible(!previewVisible),
            }}
            src={previewImage.largePreview || previewImage.url}
        />
        <StyledFormItem
          key={0 + "_image"}
          label={"Изображение"}
          name={"image"}
          rules={[
            {
              required: true,
              message: "Пожалуйста загрузите изображение!",
            },
          ]}
        >
          <div>
            <Upload
              maxCount={1}
              showUploadList={true}
              status="done"
              listType="picture-card"
              defaultFileList={fileList}
              onRemove={onRemove}
              onPreview={onPreview}
              accept="image/jpeg,image/png,image/jpg"
              beforeUpload={(file) => onBeforeUpload(file)}
            >
              <div>
                <PlusOutlined />
                <div
                  style={{
                    marginTop: 8,
                  }}
                >
                  Загрузить
                </div>
              </div>
            </Upload>
          </div>
        </StyledFormItem>
        <StyledFormItem
            key={0 + "_desktopImage"}
            label={"Изображение для сайта"}
            name={"desktopImage"}
            rules={[
              {
                required: true,
                message: "Пожалуйста загрузите изображение!",
              },
            ]}
        >
          <div>
            <Upload
                maxCount={1}
                showUploadList={true}
                status="done"
                listType="picture-card"
                defaultFileList={fileListDesktop}
                onRemove={onRemoveDesktop}
                onPreview={onPreview}
                accept="image/jpeg,image/png,image/jpg"
                beforeUpload={(file) => onBeforeUploadDesktop(file)}
            >
              <div>
                <PlusOutlined />
                <div
                    style={{
                      marginTop: 8,
                    }}
                >
                  Загрузить
                </div>
              </div>
            </Upload>
          </div>
        </StyledFormItem>
        <ButtonRow>
          <ButtonCol>
            <Button
              danger
              onClick={() => {
                createForm.resetFields()
              }}
              icon={<RotateClockwiseSvg />}
            >
              Вернуть
            </Button>
          </ButtonCol>
          <ButtonCol>
            <Button onClick={onClose} icon={<CloseSvg />}>
              Закрыть
            </Button>
          </ButtonCol>
          <ButtonCol>
            <Button icon={<SaveSvg />} type="primary" htmlType="submit" disabled={loading}>
              Сохранить
            </Button>
          </ButtonCol>
        </ButtonRow>
      </Form>
    </Drawer>
  )
}

const StyledFormItem = styled(Form.Item)`
  margin-bottom: 16px;
`
const StyledImage = styled(Image)`
  display: none;
`
const ButtonCol = styled(Col)`
  padding-bottom: 5px;
`

const ButtonRow = styled(Row)`
  align-items: center;
  justify-content: flex-end;
  margin-top: 10px;

  .ant-col {
    margin-left: 0.4em;
  }
`
